import React, { Component } from 'react';
import { shape, string, number, bool, objectOf } from 'prop-types';
import styles from './styles.scss';
import classnames from 'classnames';

export default class DeviceTableSummary extends Component {
  static propTypes = {
    summaryData: shape({
      title: string,
      ads: number,
      uniqueAds: number,
      adVisits: number,
      visitOfAds: number,
      totalVisits: number
    }).isRequired,
    title: string,
    hideChannelFields: bool,
    tableColumns: objectOf(shape({
      title: string,
      key: string
    }))
  }

  static defaultProps = {
    title: 'Grand Total'
  }

  render() {
    const { title, summaryData, hideChannelFields, tableColumns } = this.props;
    const {
      ads,
      adVisits,
      visitOfAds,
      uniqueAds = 0,
      totalVisits,
    } = summaryData;
    const formattedTotalAdVisits = `${Math.round(adVisits).toLocaleString()} (100%)`;
    const uniqueAdsLabel = `${uniqueAds ? uniqueAds.toLocaleString() : 0} Unique Ads`;
    const formattedData = {
      deviceType: title,
      adVisits: formattedTotalAdVisits,
      ads: ads.toLocaleString(),
      visitOfAds: visitOfAds.toLocaleString(),
      totalVisits,
    };

    return (
      <div className={classnames(styles.tableRow, styles.summaryRow)}>
        {
          Object.keys(tableColumns).map(key => {
            if (key === 'ads') {
              return (
                  <div key={key} className={hideChannelFields ? styles.tableCellWhenHideChannelFields : styles.tableCell}>
                    <div className={styles.adsContainer}>
                    <span data-test="summaryAds" className={styles.adsValue}>
                      {formattedData[key]}
                    </span>
                    <div data-test="summaryAdsLabel" className={styles.uniqueContainer}>
                      {uniqueAdsLabel}
                    </div>
                  </div>
                </div>
              )
            }

            return (
              <div
                key={key}
                className={hideChannelFields ? styles.tableCellWhenHideChannelFields : styles.tableCell}
                data-test={"summary" + key.charAt(0).toUpperCase() + key.slice(1)}
              >
                {formattedData[key]}
              </div>
              )
            })
        }
      </div>
    )
  }
}
